import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useGuestStore } from '~/store/guest'
import { useResetState } from '~/composables/useResetState'

export default defineNuxtRouteMiddleware(async (to) => {
  // Ignore devtools requests
  if (
    to.path.startsWith('/.well-known/') ||
    to.meta.skipMiddleware ||
    import.meta.server
  )
    return

  const {
    campaign,
    gift: giftQueryParam,
    partner,
    email: adminEmail,
  } = to.query
  const guestStore = useGuestStore()

  if (campaign && giftQueryParam) {
    if (
      !guestStore.gift?.id ||
      guestStore.gift?.policyId !== String(campaign)
    ) {
      const { resetState } = useResetState()
      resetState(false)

      await guestStore.loadGift(campaign as string, true)

      if (!guestStore.gift?.id) {
        if (guestStore.requestError?.statusCode === 410) {
          return navigateTo('/expired')
        }
        return navigateTo('/welcome', { external: true })
      } else {
        guestStore.guest.adminEmail = adminEmail
          ? decodeURIComponent(adminEmail as string)
          : ''
      }
    }
  } else if (
    guestStore.isAdminGift &&
    !giftQueryParam &&
    !campaign &&
    !partner
  ) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        campaign: guestStore.gift?.policyId,
        gift: guestStore.gift?.id,
      },
    })
  }
})
